import { UserManager } from 'oidc-client'
import { resolve } from '../dependencies'
import { getConfig } from './utils/configUtils'

var BASE_URL = getConfig('REACT_APP_API_URL', '')

function jsonPostHeader(antiforgeryKey, antiforgeryValue) {
    let header = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
    header[antiforgeryKey] = antiforgeryValue
    return header
}

function apiHeader(kundeId, brukerId, apisessionId, accessToken) {
    var headers = {
        Accept: 'application/json',
        KundeId: kundeId,
        BrukerId: brukerId,
        ApiSession: apisessionId
    }
    if (accessToken) {
        headers['Authorization'] = 'Bearer ' + accessToken
    }
    return headers
}

export default class Repository {
    constructor(antiforgeryKey, antiforgeryValue) {
        this._header = jsonPostHeader('test', 'test')
        this._kundeId = ''
    }

    _get(path, kundeId, brukerId, apisessionId, accessToken) {
        return fetch(this._tjenesteUrl(path), {
            method: 'GET',
            headers: apiHeader(kundeId, brukerId, apisessionId, accessToken)
        }).then(response => {
            if (response.status === 401) {
                return this._handleUnauthorized(user =>
                    fetch(this._tjenesteUrl(path), {
                        method: 'GET',
                        headers: apiHeader(user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
                    }).then(r => {
                        if (!r.ok) throw new Error('unauthorized_retry')
                        return r.json()
                    })
                )
            }
            if (!response.ok) {
                const err = new Error('HTTP ' + response.status)
                err.status = response.status
                throw err
            }
            return response.json()
        })
    }

    _handleUnauthorized(retryWithUser) {
        return resolve(UserManager)
            .signinSilent()
            .then(user => retryWithUser(user))
            .catch(() => {
                resolve(UserManager).signinRedirect()
                return new Promise(() => {}) // Venter mens siden omdirigeres til innlogging
            })
    }

    _put(path, data, kundeId, brukerId, apisessionId, accessToken) {
        return fetch(this._tjenesteUrl(path), {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: Object.assign(apiHeader(kundeId, brukerId, apisessionId, accessToken), {
                'Content-Type': 'application/json'
            })
        }).then(response => {
            if (!response.ok) {
                const err = new Error('HTTP ' + response.status)
                err.status = response.status
                throw err
            }
            return response.json()
        })
    }

    _post(path, data, kundeId, brukerId, apisessionId, accessToken) {
        return fetch(this._tjenesteUrl(path), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: Object.assign(apiHeader(kundeId, brukerId, apisessionId, accessToken), {
                'Content-Type': 'application/json'
            })
        })
            .then(response => {
                return response.ok ? response.text() : response
            })
            .then(response => {
                if (!response.ok){
                    return response;
                }
                return response ? JSON.parse(response) : null;

            })
    }

    _delete(path, kundeId, brukerId, apisessionId, accessToken) {
        return fetch(this._tjenesteUrl(path), {
            method: 'DELETE',
            headers: apiHeader(kundeId, brukerId, apisessionId, accessToken)
        }).then(response => {
            return response.json()
        })
    }

    _tjenesteUrl(path) {
        let host = BASE_URL
        return host + path
    }

    hentBytter(token) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    `TableStorage?kundeId=${user.profile.kundeid}${token ?  `&continueToken=${token}` : ''}`,
                    user.profile.kundeid,
                    user.profile.name,
                    user.profile.apisession,
                    user.access_token
                );
            })
    }


    hentVannmaalere() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Vannmaaler?kundeId=' + user.profile.kundeid,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentAvtaler() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Avtale?kundeId=' + user.profile.kundeid,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    opprettNyArbeidsliste(arbeidsliste) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._post(
                    'Arbeidslister',
                    arbeidsliste,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentArbeidslister() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('Arbeidslister/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentArbeidslisterForBruker() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Arbeidslister?brukernavn=' + user.profile.name, user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentArbeidslisteMedId(id) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('Arbeidslister/' + id, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentSmsForArbeidsliste(id) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('ArbeidslisteSms/' + id, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    oppdateArbeidsliste(arbeidsliste) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._put(
                    'Arbeidslister/',
                    arbeidsliste,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    fjernArbeidsliste(id) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._delete('Arbeidslister/' + id, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentMaalerstatus() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('MaalerStatusTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentSoner() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('Sone/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentDatagrunnlag(kundenavn) {
        return this._get('Datagrunnlag?kundenavn=' + kundenavn)
    }

    hentVannmaalerMedId(vannmaalerid, listeId) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Vannmaaler?id=' + vannmaalerid + '&listeId=' + listeId,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    fjernMaalerFraArbeidsliste(maalerId) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._delete(
                    'Arbeidslistemaalere/' + maalerId,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    oppdateVannmaalerPaaAbeidsliste(vannmaaler, oppdateVannmaalerPaaAbeidsliste) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._put(
                    'Arbeidslistemaalere?beregntidspunkt=' + oppdateVannmaalerPaaAbeidsliste,
                    vannmaaler,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentPlasseringer() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('PlasseringTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentRetning() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('RetningTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentBrukere() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('Bruker/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentVannmalerTyper() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('VannMaalerTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentFabrikat() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('FabrikatTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentDimensjon() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('DimensjonTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentKapasitet() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('Kapasitet/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentAvlesertyper() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get('AvleserTyper/', user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    sendVarselForArbeidsliste(varsel) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._post('Sms/', varsel, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    leggTilBildeBytte(bildeObjekt) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._post('Bilde/', bildeObjekt, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    hentEgendefinerteMaalertyper() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'EgendefinertVannmaalertype/',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    utforeMaalerSkifte(data) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._post('Utskifting', data, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }

    leggTilEgendefinerteMaalertype(data) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                data.KundeId = user.profile.kundeid
                return this._post(
                    'EgendefinertVannmaalertype/',
                    data,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    oppdaterTilEgendefinerteMaalertype(data) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                data.KundeId = user.profile.kundeid
                return this._put(
                    'EgendefinertVannmaalertype/',
                    data,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    slettEgendefinerteMaalertype(id) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._delete(
                    'EgendefinertVannmaalertype/' + id,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentSmsMalForKunde() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Innstillinger?navn=SmsMal',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentSmsTidspunktInnstillingForKunde() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Innstillinger?navn=BrukEksaktTidspunktISMS',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentLunsjtidspunktForKunde() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Innstillinger?navn=LunsjTidspunkt',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentTidPerMaaler() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Innstillinger?navn=ArbeidstidprMaaler',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentLunsjTidMinutter() {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Innstillinger?navn=LunsjtidMinutter',
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    hentPoststedForVannmaaler(maalerId) {
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._get(
                    'Poststed/' + maalerId,
                    user.profile.kundeid,
                    user.profile.name, user.profile.apisession,
                    user.access_token
                )
            })
    }

    lagreInnstillingForKunde(data) {
        console.log(data)
        return resolve(UserManager)
            .getUser()
            .then(user => {
                return this._put('Innstillinger', data, user.profile.kundeid, user.profile.name, user.profile.apisession, user.access_token)
            })
    }
}



// WEBPACK FOOTER //
// ./src/felles/repository.js